module.exports = __webpack_public_path__ + "static/img/AL.102c58c5.png";